module.exports = __webpack_public_path__ + "07_face.59a6ad96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/07_face.png
// module id = iJRq
// module chunks = 0